module.exports = __webpack_public_path__ + "static/img/14.bdcc8ba4.png";